import React from "react";
import BackgroundSection from "components/backgrounds/BackgroundSection";
import FeaturedItemsSlider from "components/featured-items-slider/FeaturedItemsSlider";
import { FEATURED_COUNTRIES } from "data/featured-countries";

const PopularHolidayDestinationsEurope = ({ slice }) => {
  const { title, description, itemsPerRow, cardType, sliderStyle } =
    slice.primary;

  const uniqueId = `popular-destinations-europe-${title
    .toString()
    .replace(/ /g, "")}`;

  return (
    <div className="relative py-16">
      <BackgroundSection className="bg-orange-50 dark:bg-black dark:bg-opacity-20 " />
      <FeaturedItemsSlider
        uniqueId={uniqueId}
        countries={FEATURED_COUNTRIES}
        categoryCardType={cardType}
        itemPerRow={itemsPerRow}
        heading={title}
        subHeading={description}
        sliderStyle={sliderStyle}
      />
    </div>
  );
};
export default PopularHolidayDestinationsEurope;
